import styled from '@emotion/styled';

// This primarily exists as an anchor for the panel open/close animation
export const StyledSlideWrapper = styled.div`
  position: relative;
`;
